const LINE_SPACING_TYPE = "line-spacing";

export { LINE_SPACING_TYPE };
//# sourceMappingURL=types.js.map
